import { styled } from '@styles';
import ReactSlider from 'react-slider';

export const Slider = styled(ReactSlider)`
  width: 100%;
  height: 20px;
`;

export const ThumbWrapper = styled.div`
  position: absolute;
  left: -25px;
  top: -5px;
`;

export const ThumbButton = styled.button<{ minus: boolean }>`
  cursor: pointer;
  position: relative;
  outline: none;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #fff;
  border: 1px solid ${({ theme: { colors } }) => colors.red};
  transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;
  position: absolute;
  top: -2px;
  left: ${({ minus }) => (minus ? '-30px' : '60px')};
`;

export const ThumbLabel = styled.div`
  font-size: ${({ theme }) => theme.typography.smallFontSize};
  border-radius: 30px;
  text-align: center;
  padding: 2px;
  cursor: grab;
  width: 60px;
  color: #4f6e7c;
  background-color: #fff;
  border: 1px solid ${({ theme: { colors } }) => colors.red};
  position: absolute;
  top: 0px;
`;

export const Track = styled.div<{ index?: number }>`
  bottom: 50%;
  background: ${({ index, theme: { colors } }) =>
    index === 0 ? colors.red : '#ddd'};
  height: 4px;
`;

export const Mark = styled.span<{ active: boolean }>`
  width: 8px;
  height: 8px;
  background-color: ${({ active, theme: { colors } }) =>
    active ? colors.red : '#c5ced3'};
  border-radius: 50%;
  cursor: pointer;
  vertical-align: middle;
  top: 4px;
`;
